/* eslint-disable class-methods-use-this */
// eslint-disable-next-line no-shadow
/**
 * pc端用electron-store做本地存储
 * web需要单独实现
 */
import { IS_PC } from '@/common/constant/platform';

let ElectronStore: typeof import('electron-store');
if (IS_PC) {
  ElectronStore = (window.parent as any).require('electron-store') as typeof import('electron-store');
}

export default class Store {
  private eStore: any;

  constructor(storeKey = 'config') {
    if (IS_PC) {
      this.eStore = new ElectronStore({ name: storeKey });
    } else {
      this.eStore = window.localStorage || localStorage;
    }
  }

  set(key: string, value: unknown): void {
    let val;
    try {
      val = JSON.stringify(value);
    } catch (error) {
      val = value;
    }
    if (IS_PC) {
      this.eStore.set(key, val);
    } else {
      this.eStore.setItem(key, val);
    }
  }

  get<T>(key: string): T {
    let value;
    const info: string = IS_PC ? (this.eStore.get(key) as string) : (this.eStore.getItem(key) as string);
    try {
      value = JSON.parse(info as string);
    } catch (e) {
      // error
    }

    return value || info;
  }

  del(key: string): void {
    if (IS_PC) {
      this.eStore.delete(key);
    } else {
      this.eStore.removeItem(key);
    }
  }
}
